import React from "react";
import { PageHeader } from "../../components";
import { Link } from "react-router-dom";
import "./menu.css";

const Menu = () => {
  return (
    <div className="page-content">
      <PageHeader title="Menu" page="menu" />

      {/* Menu Content */}
      <div className="page-content">
        <div className="content">
          {/* Welcome Section */}
          <div className="section-full bg-white content-inner">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center section-head">
                  <h2 className="h3 text-uppercase">
                    <span className="text-primary">Lagos Country Club</span>
                  </h2>
                  <h3 className="h4 font-weight-bold">Menu</h3>
                  <div className="dlab-separator-outer">
                    <div className="dlab-separator bg-primary style-liner"></div>
                  </div>
                  <div className="clear"></div>
                  <p className="m-b30">
                    Welcome to our dining experience. Choose from our carefully
                    curated selection of food and beverages.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Menu Buttons Section */}
          <div className="section-full bg-gray content-inner">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8 col-md-10">
                  <div className="menu-buttons-container">
                    {/* Food Menu Button */}
                    <div className="menu-button-wrapper">
                      <a
                        href="https://admin.lagoscountryclub.net/foodlist.php"
                        className="menu-button food-button"
                      >
                        <div className="menu-icon">
                          <i className="fa fa-cutlery"></i>
                        </div>
                        <h3>Food Menu</h3>
                        <p>Explore our delicious food offerings</p>
                        <span className="button-arrow">→</span>
                      </a>
                    </div>

                    {/* Drinks Menu Button */}
                    <div className="menu-button-wrapper">
                      <a
                        href="https://admin.lagoscountryclub.net/drinkslist.php"
                        className="menu-button drinks-button"
                      >
                        <div className="menu-icon">
                          <i className="fa fa-glass"></i>
                        </div>
                        <h3>Drinks Menu</h3>
                        <p>Browse our beverage selection</p>
                        <span className="button-arrow">→</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
